import { formatInTimeZone } from 'date-fns-tz';
import packageJson from '../../../package.json';

const packageVersion = (packageJson as { version: string }).version || '0.0.0';

const generateDefaultBuildNumber = (): string => {
  const now = new Date();
  const datePart = formatInTimeZone(now, 'UTC', 'MMddyy');
  const buildCount = '01';
  return `${datePart}${buildCount}`;
};

export const getBuildNumber = (): string => {
  return process.env.REACT_APP_BUILD_NUMBER || generateDefaultBuildNumber();
};

export const getAppVersion = (): string => {
  return process.env.REACT_APP_VERSION || packageVersion;
};